export enum DoorLouverInstallation {
  PP = 'Panel in Place',
  CO = 'Cutout Only',
  CR = 'Cutout w/ Reinforcement',
  RCO = 'Round Cutout Only',
  INST = 'Installed',
}
